import { useState, useEffect } from "react";
import { FC, MouseEvent } from "react";
import { InputDinamycPlaceholder, ButtonBasic, CheckboxToggleBlue, Checkbox } from '@lk-gtcom/ecomlab-components';
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from "../../../store/general";
import { ModalComponent } from "../../../components/Modal/ModalComponent/ModalComponent";
import { useResponseHandler } from "../../../common/auth";
import "./ModalAddNewField.scss";

type CurrentRow = {
  row_id: string,
  Значение: 'string',
  "Количество дней": number,
  'Единица измерения': string,
  Название: string
}

interface ModalEditFileProps {
  setIsModal: (isOpen: boolean) => void;
  selectedApi: { label: string, value: string | number },
  selectedMp: { label: string, value: string | number },
  status?: string,
  currentRow: CurrentRow,
  setСurrentRow: (currentRow: CurrentRow | null) => void,
}

const ModalAddNewField: FC<ModalEditFileProps> = ({
  setIsModal,
  selectedApi,
  selectedMp,
  currentRow,
  setСurrentRow
}) => {

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();

  const [name, setName] = useState<string>(currentRow?.['Название'] || '')
  const [value, setValue] = useState<number | string>(currentRow?.['Значение'] || '')
  const [oldName, setOldName] = useState<string>(currentRow?.['Название'] || '')
  const [isPercent, setIsPercent] = useState<boolean>(currentRow ? currentRow?.['Единица измерения']?.includes('%') : false)
  const [isAll, setIsAll] = useState<boolean>(false)

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    setСurrentRow(null)
    setIsModal(false)
  };

  const handleChangeName = (e: string) => {
    setName(e);
  }

  const handleChangeValue = (e: string) => {
    setValue(e);
  }

  const handleChangePercent = (e: boolean) => {
    setIsPercent(!isPercent);
  }

  const handleClickBtn = (e: MouseEvent<HTMLDivElement>) => {
    fetchAddExpenses()
    setСurrentRow(null)
    setIsModal(false)
  }

  // Инфа по параметру
  const fetchGetAttrs = () => {
    if (selectedApi?.value) {
      let url: string = `https://apps1.ecomru.ru:4655/v1/user-price-attrs/models/item`

      const body = JSON.stringify({
        api_id: selectedApi?.value,
        mp_id: selectedMp?.value,
        attribute_name: name,
      });

      fetch(url, { body, method: 'POST', headers })
        .then(handleTableResponse)
        .then((json) => {
          const { for_all_products, value_float } = json
          setIsAll(for_all_products)
          setValue(value_float)
        })
        .catch(handleRequestError);
    }
  };

  // Создание и редактирование
  const fetchAddExpenses = () => {
    if (selectedApi?.value) {
      let url: string = `https://apps1.ecomru.ru:4655/v1/user-price-attrs/models`

      const value_float = isAll ? { value_float: value } : {}

      const body = JSON.stringify({
        api_id: selectedApi?.value,
        mp_id: selectedMp?.value,
        attribute_name: name,
        is_percent: isPercent,
        old_attribute_name: oldName,
        for_all_products: isAll,
        ...value_float
      });

      fetch(url, { body, method: currentRow ? 'PUT' : 'POST', headers })
        .then(handleTableResponse)
        .then((json) => setСurrentRow(null))
        .catch(handleRequestError);
    }
  };

  useEffect(() => {
    if (currentRow) {
      fetchGetAttrs()
    }
  }, [currentRow]);

  return (
    <ModalComponent
      title={currentRow ? "Редактирование поля" : "Новое поле"}
      onClose={handleClick}
      style={{ maxWidth: '500px', height: 'auto' }}
      child={
        <div className="modal-add-new-field__content">

          <InputDinamycPlaceholder
            placeholder='Название'
            onChange={handleChangeName}
            changeValue={name}
            size='s'
            disabled={name == 'Себестоимость' || name == 'Маржинальность'}
          />

          {isAll && <InputDinamycPlaceholder
            placeholder='Значение'
            type='number'
            onChange={handleChangeValue}
            changeValue={String(value)}
            size='s'
          />}

          {name != 'Себестоимость' && <div className="modal-add-new-field__label">
            <span>руб.</span>
            <CheckboxToggleBlue
              value={isPercent}
              onChange={handleChangePercent}
            />
            <span>%</span>
          </div>}

          <Checkbox
            value={isAll}
            onChange={setIsAll}
          >
            Использоваться для всех товаров
          </Checkbox>

          <div className="modal-add-new-field__btn-box">
            <ButtonBasic
              green
              text='Применить'
              onClick={handleClickBtn}
            />
          </div>
        </div>}
    />
  );
};

export { ModalAddNewField };